<template>
  <div class="footerWrapper">
    <div>苏ICP备10219514号-1</div>
    <div class="rightPart">
      <img
        src="../assets/images/police.png"
        alt=""
      />
      <div>苏公网安备 32050802011260号</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="less" scoped>
.footerWrapper {
  width: 1280px;
  height: 50px;
  display: flex;
  font-size: 14px;
  color: #2a2a2a;
  margin: 20px auto 0;
  align-items: center;
  justify-content: space-between;
  user-select: none;
  .rightPart {
    display: flex;
    align-items: center;
    img {
      margin-right: 4px;
      width: 14px;
      height: 14px;
    }
  }
}
</style>
